/**
 * This file was auto-generated by Fern from our API Definition.
 */

import * as Truvity from '../../api/index';
import * as core from '../../core';
import * as serializers from '../index';

export const NotInResourceId: core.serialization.ObjectSchema<
    serializers.NotInResourceId.Raw,
    Truvity.NotInResourceId
> = core.serialization.object({
    values: core.serialization.list(core.serialization.string()),
});

export declare namespace NotInResourceId {
    export interface Raw {
        values: string[];
    }
}
